import SearchParamsBase from '../../../Elements/SearchParamsBase';

export default class CommissionRateSearchParams extends SearchParamsBase {
  static saveType = 'CommissionRateSearchParams';
  initialize() {
    this.UserId = null;
    this.Year = null;
    this.IsOrWillBeActive = null;
  }
}
